<template>
  <div>
    <label class="label">Planilha</label>
    <input
      :state="Boolean(file)"
      type="file"
      placeholder="Importar planilha..."
      drop-placeholder="Importar planilha..."
    >
  </div>
</template>

<script>
  export default {
    name: 'InputFile',
    data() {
      return {
        file1: null,
      }
    }
  }
</script>


<style lang="scss">
  .has-addons {
    display: flex;
    flex-direction: column;
    input {
      &:last-child {
        margin-top: 12px;
      }
    }
    .is-clearfix {
      &:first-child {
        margin-top: -10px;
      }
    }
  }
</style>
